import React, { useState, useEffect } from 'react';

export function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // PWA가 이미 설치되었는지 확인
    const checkInstalled = () => {
      if (window.matchMedia('(display-mode: standalone)').matches || 
          window.navigator.standalone === true) {
        setIsInstalled(true);
      }
    };

    checkInstalled();

    // beforeinstallprompt 이벤트 리스너
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      
      // 첫 방문이거나 이전에 설치를 거부하지 않았다면 프롬프트 표시
      const installPromptDismissed = localStorage.getItem('installPromptDismissed');
      if (!installPromptDismissed && !isInstalled) {
        setTimeout(() => setShowPrompt(true), 3000); // 3초 후 표시
      }
    };

    // PWA 설치 완료 이벤트
    const handleAppInstalled = () => {
      setIsInstalled(true);
      setShowPrompt(false);
      setDeferredPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, [isInstalled]);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    // 설치 프롬프트 표시
    deferredPrompt.prompt();
    
    // 사용자 선택 결과 대기
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      console.log('사용자가 설치를 수락했습니다');
    } else {
      console.log('사용자가 설치를 거부했습니다');
      localStorage.setItem('installPromptDismissed', 'true');
    }
    
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('installPromptDismissed', 'true');
  };

  // 이미 설치되었거나 프롬프트가 없으면 렌더링하지 않음
  if (isInstalled || !showPrompt || !deferredPrompt) {
    return null;
  }

  return (
    <div className="install-prompt-overlay">
      <div className="install-prompt">
        <div className="install-prompt-content">
          <div className="install-icon">
            <i className="fas fa-mobile-alt"></i>
          </div>
          <h3>앱으로 설치하기</h3>
          <p>
            노틸러스를 홈 화면에 추가하여<br />
            더 빠르고 편리하게 사용하세요!
          </p>
          <div className="install-benefits">
            <div className="benefit-item">
              <i className="fas fa-bolt"></i>
              <span>빠른 실행</span>
            </div>
            <div className="benefit-item">
              <i className="fas fa-bell"></i>
              <span>알림 받기</span>
            </div>
            <div className="benefit-item">
              <i className="fas fa-wifi"></i>
              <span>오프라인 사용</span>
            </div>
          </div>
        </div>
        <div className="install-prompt-actions">
          <button 
            className="install-button install-primary"
            onClick={handleInstallClick}
          >
            <i className="fas fa-download"></i>
            설치하기
          </button>
          <button 
            className="install-button install-secondary"
            onClick={handleDismiss}
          >
            나중에
          </button>
        </div>
      </div>
    </div>
  );
} 